import { render, staticRenderFns } from "./DevelopView.vue?vue&type=template&id=4da88d58&scoped=true&"
import script from "./DevelopView.vue?vue&type=script&lang=js&"
export * from "./DevelopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da88d58",
  null
  
)

export default component.exports